<template>
  <div>
    <AppPaginaBarraSuperior :items="items" :menu-lateral="true" />
    <AppPaginaTitulo
      titulo="Informação da Licença"
      descricao="Informações da licença do servidor"
    />
    <div class="card m-3 shadow-sm">
      <div class="card-body">
        <div class="expiraEmInfo">
          <div>Expira Em:</div>
          <div class="dataValidade">{{ diasRestantes }}</div>
        </div>
        <div class="mt-2">
          <VerificarLicencaBtn
            :servidor="licenca"
            :enviarLicenca="setLicenca"
          />
          <NovaLicencaBtn :servidor="licenca" :enviarLicenca="setLicenca" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import ServidorApi from "../api/servidorApi";

import AppPaginaBarraSuperior from "../components/layout/AppPaginaBarraSuperior.vue";
import AppPaginaTitulo from "../components/layout/AppPaginaTitulo.vue";
import NovaLicencaBtn from "../components/servidor/NovaLicencaBtn.vue";
import VerificarLicencaBtn from "../components/servidor/VerificarLicencaBtn.vue";

export default {
  name: "licencas",
  components: {
    AppPaginaBarraSuperior,
    AppPaginaTitulo,
    NovaLicencaBtn,
    VerificarLicencaBtn
  },
  data() {
    return {
      items: [
        {
          text: "Licença",
          active: true
        }
      ],
      licenca: {}
    };
  },
  computed: {
    diasRestantes() {
      return this.licenca
        ? `${moment(this.licenca.vencimento).diff(moment(), "days")} dia(s)`
        : "";
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.setLicenca();
    });
  },
  methods: {
    setLicenca() {
      ServidorApi.verificarLicenca().then(resp => {
        this.licenca = resp.licenca;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.expiraEmInfo {
  padding-left: 0.5rem;
  font-size: 1.3rem;
  display: flex;

  .dataValidade {
    font-weight: bold;
    margin-left: 0.5rem;
  }
}
</style>
